<div fxLayout="column" style="padding:15px;">

  <app-page-header [title]="pageTitle" action=''></app-page-header>
</div>
<div fxLayout="column" fxLayoutAlign="center center" style="margin-top:20px; padding-left:15px; padding-right: 15px;">

  <div fxLayout="column" fxFlex.gt-sm="100" fxFlex.lt-md="100"   ngStyle.lt-md="width:100%" ngStyle.md ="width:100%"  ngStyle.lt-lg="width:100%;" ngStyle.gt-lg = "width:65%">
    <table>
      <tr>
        <th>

      </th>
      </tr>
    </table>
  </div>
</div>
